import { render, staticRenderFns } from "./PeriodicidadPago.vue?vue&type=template&id=47c8e0d2&scoped=true"
import script from "./PeriodicidadPago.vue?vue&type=script&lang=js"
export * from "./PeriodicidadPago.vue?vue&type=script&lang=js"
import style0 from "./PeriodicidadPago.vue?vue&type=style&index=0&id=47c8e0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c8e0d2",
  null
  
)

export default component.exports